import React from 'react';

import { AreaNoClick, Container, Content } from './styles';

const Modal = props => {
  return (
    <Container active={props.active}>
      <AreaNoClick onClick={() => props.handler()} />
      <Content small={props.small} large={props.large}>
        {props.children}
      </Content>
    </Container>
  );
};

export default Modal;
